//Get login User Details
export const FETCH_LOGIN_USER_SUCCESS = 'FETCH_LOGIN_USER_SUCCESS';
export const FETCH_LOGIN_USER_FAILURE = 'FETCH_LOGIN_USER_FAILURE';

//Update Login User Details
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS';
export const UPDATE_USER_DETAILS_FAILURE = 'UPDATE_USER_DETAILS_FAILURE';

export const RESET = 'RESET';
